import { render, staticRenderFns } from "./SchoolQuestionnaire.vue?vue&type=template&id=68b5a2c5&scoped=true&"
import script from "./SchoolQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./SchoolQuestionnaire.vue?vue&type=script&lang=js&"
import style0 from "./SchoolQuestionnaire.vue?vue&type=style&index=0&id=68b5a2c5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b5a2c5",
  null
  
)

export default component.exports